/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as AuthedIndexRouteImport } from './routes/_authed/index'
import { Route as AuthedSettingsRouteImport } from './routes/_authed/settings'
import { Route as AuthedCompanySlugRouteImport } from './routes/_authed/$companySlug'
import { Route as AuthedCompanySlugIndexRouteImport } from './routes/_authed/$companySlug/index'
import { Route as AuthedCompanySlugSchemaRouteImport } from './routes/_authed/$companySlug/schema'
import { Route as AuthedCompanySlugQuarantineRouteImport } from './routes/_authed/$companySlug/quarantine'
import { Route as AuthedCompanySlugLicenseRouteImport } from './routes/_authed/$companySlug/license'
import { Route as AuthedCompanySlugRunsIndexRouteImport } from './routes/_authed/$companySlug/runs/index'
import { Route as AuthedCompanySlugReportsIndexRouteImport } from './routes/_authed/$companySlug/reports/index'
import { Route as AuthedCompanySlugJobsIndexRouteImport } from './routes/_authed/$companySlug/jobs/index'
import { Route as AuthedCompanySlugRunsRunIdRouteImport } from './routes/_authed/$companySlug/runs/$runId'
import { Route as AuthedCompanySlugReportsNewRouteImport } from './routes/_authed/$companySlug/reports/new'
import { Route as AuthedCompanySlugJobsNewRouteImport } from './routes/_authed/$companySlug/jobs/new'
import { Route as AuthedCompanySlugReportsReportIdIndexRouteImport } from './routes/_authed/$companySlug/reports/$reportId/index'
import { Route as AuthedCompanySlugReportsReportIdEditRouteImport } from './routes/_authed/$companySlug/reports/$reportId/edit'
import { Route as AuthedCompanySlugJobsJobIdEditRouteImport } from './routes/_authed/$companySlug/jobs/$jobId/edit'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedRoute = AuthedRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedIndexRoute = AuthedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSettingsRoute = AuthedSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedCompanySlugRoute = AuthedCompanySlugRouteImport.update({
  id: '/$companySlug',
  path: '/$companySlug',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedCompanySlugIndexRoute = AuthedCompanySlugIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedCompanySlugRoute,
} as any)
const AuthedCompanySlugSchemaRoute = AuthedCompanySlugSchemaRouteImport.update({
  id: '/schema',
  path: '/schema',
  getParentRoute: () => AuthedCompanySlugRoute,
} as any)
const AuthedCompanySlugQuarantineRoute =
  AuthedCompanySlugQuarantineRouteImport.update({
    id: '/quarantine',
    path: '/quarantine',
    getParentRoute: () => AuthedCompanySlugRoute,
  } as any)
const AuthedCompanySlugLicenseRoute =
  AuthedCompanySlugLicenseRouteImport.update({
    id: '/license',
    path: '/license',
    getParentRoute: () => AuthedCompanySlugRoute,
  } as any)
const AuthedCompanySlugRunsIndexRoute =
  AuthedCompanySlugRunsIndexRouteImport.update({
    id: '/runs/',
    path: '/runs/',
    getParentRoute: () => AuthedCompanySlugRoute,
  } as any)
const AuthedCompanySlugReportsIndexRoute =
  AuthedCompanySlugReportsIndexRouteImport.update({
    id: '/reports/',
    path: '/reports/',
    getParentRoute: () => AuthedCompanySlugRoute,
  } as any)
const AuthedCompanySlugJobsIndexRoute =
  AuthedCompanySlugJobsIndexRouteImport.update({
    id: '/jobs/',
    path: '/jobs/',
    getParentRoute: () => AuthedCompanySlugRoute,
  } as any)
const AuthedCompanySlugRunsRunIdRoute =
  AuthedCompanySlugRunsRunIdRouteImport.update({
    id: '/runs/$runId',
    path: '/runs/$runId',
    getParentRoute: () => AuthedCompanySlugRoute,
  } as any)
const AuthedCompanySlugReportsNewRoute =
  AuthedCompanySlugReportsNewRouteImport.update({
    id: '/reports/new',
    path: '/reports/new',
    getParentRoute: () => AuthedCompanySlugRoute,
  } as any)
const AuthedCompanySlugJobsNewRoute =
  AuthedCompanySlugJobsNewRouteImport.update({
    id: '/jobs/new',
    path: '/jobs/new',
    getParentRoute: () => AuthedCompanySlugRoute,
  } as any)
const AuthedCompanySlugReportsReportIdIndexRoute =
  AuthedCompanySlugReportsReportIdIndexRouteImport.update({
    id: '/reports/$reportId/',
    path: '/reports/$reportId/',
    getParentRoute: () => AuthedCompanySlugRoute,
  } as any)
const AuthedCompanySlugReportsReportIdEditRoute =
  AuthedCompanySlugReportsReportIdEditRouteImport.update({
    id: '/reports/$reportId/edit',
    path: '/reports/$reportId/edit',
    getParentRoute: () => AuthedCompanySlugRoute,
  } as any)
const AuthedCompanySlugJobsJobIdEditRoute =
  AuthedCompanySlugJobsJobIdEditRouteImport.update({
    id: '/jobs/$jobId/edit',
    path: '/jobs/$jobId/edit',
    getParentRoute: () => AuthedCompanySlugRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthedIndexRoute
  '/login': typeof LoginRoute
  '/$companySlug': typeof AuthedCompanySlugRouteWithChildren
  '/settings': typeof AuthedSettingsRoute
  '/$companySlug/license': typeof AuthedCompanySlugLicenseRoute
  '/$companySlug/quarantine': typeof AuthedCompanySlugQuarantineRoute
  '/$companySlug/schema': typeof AuthedCompanySlugSchemaRoute
  '/$companySlug/': typeof AuthedCompanySlugIndexRoute
  '/$companySlug/jobs/new': typeof AuthedCompanySlugJobsNewRoute
  '/$companySlug/reports/new': typeof AuthedCompanySlugReportsNewRoute
  '/$companySlug/runs/$runId': typeof AuthedCompanySlugRunsRunIdRoute
  '/$companySlug/jobs/': typeof AuthedCompanySlugJobsIndexRoute
  '/$companySlug/reports/': typeof AuthedCompanySlugReportsIndexRoute
  '/$companySlug/runs/': typeof AuthedCompanySlugRunsIndexRoute
  '/$companySlug/jobs/$jobId/edit': typeof AuthedCompanySlugJobsJobIdEditRoute
  '/$companySlug/reports/$reportId/edit': typeof AuthedCompanySlugReportsReportIdEditRoute
  '/$companySlug/reports/$reportId/': typeof AuthedCompanySlugReportsReportIdIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/settings': typeof AuthedSettingsRoute
  '/': typeof AuthedIndexRoute
  '/$companySlug/license': typeof AuthedCompanySlugLicenseRoute
  '/$companySlug/quarantine': typeof AuthedCompanySlugQuarantineRoute
  '/$companySlug/schema': typeof AuthedCompanySlugSchemaRoute
  '/$companySlug': typeof AuthedCompanySlugIndexRoute
  '/$companySlug/jobs/new': typeof AuthedCompanySlugJobsNewRoute
  '/$companySlug/reports/new': typeof AuthedCompanySlugReportsNewRoute
  '/$companySlug/runs/$runId': typeof AuthedCompanySlugRunsRunIdRoute
  '/$companySlug/jobs': typeof AuthedCompanySlugJobsIndexRoute
  '/$companySlug/reports': typeof AuthedCompanySlugReportsIndexRoute
  '/$companySlug/runs': typeof AuthedCompanySlugRunsIndexRoute
  '/$companySlug/jobs/$jobId/edit': typeof AuthedCompanySlugJobsJobIdEditRoute
  '/$companySlug/reports/$reportId/edit': typeof AuthedCompanySlugReportsReportIdEditRoute
  '/$companySlug/reports/$reportId': typeof AuthedCompanySlugReportsReportIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authed': typeof AuthedRouteWithChildren
  '/login': typeof LoginRoute
  '/_authed/$companySlug': typeof AuthedCompanySlugRouteWithChildren
  '/_authed/settings': typeof AuthedSettingsRoute
  '/_authed/': typeof AuthedIndexRoute
  '/_authed/$companySlug/license': typeof AuthedCompanySlugLicenseRoute
  '/_authed/$companySlug/quarantine': typeof AuthedCompanySlugQuarantineRoute
  '/_authed/$companySlug/schema': typeof AuthedCompanySlugSchemaRoute
  '/_authed/$companySlug/': typeof AuthedCompanySlugIndexRoute
  '/_authed/$companySlug/jobs/new': typeof AuthedCompanySlugJobsNewRoute
  '/_authed/$companySlug/reports/new': typeof AuthedCompanySlugReportsNewRoute
  '/_authed/$companySlug/runs/$runId': typeof AuthedCompanySlugRunsRunIdRoute
  '/_authed/$companySlug/jobs/': typeof AuthedCompanySlugJobsIndexRoute
  '/_authed/$companySlug/reports/': typeof AuthedCompanySlugReportsIndexRoute
  '/_authed/$companySlug/runs/': typeof AuthedCompanySlugRunsIndexRoute
  '/_authed/$companySlug/jobs/$jobId/edit': typeof AuthedCompanySlugJobsJobIdEditRoute
  '/_authed/$companySlug/reports/$reportId/edit': typeof AuthedCompanySlugReportsReportIdEditRoute
  '/_authed/$companySlug/reports/$reportId/': typeof AuthedCompanySlugReportsReportIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/$companySlug'
    | '/settings'
    | '/$companySlug/license'
    | '/$companySlug/quarantine'
    | '/$companySlug/schema'
    | '/$companySlug/'
    | '/$companySlug/jobs/new'
    | '/$companySlug/reports/new'
    | '/$companySlug/runs/$runId'
    | '/$companySlug/jobs/'
    | '/$companySlug/reports/'
    | '/$companySlug/runs/'
    | '/$companySlug/jobs/$jobId/edit'
    | '/$companySlug/reports/$reportId/edit'
    | '/$companySlug/reports/$reportId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/settings'
    | '/'
    | '/$companySlug/license'
    | '/$companySlug/quarantine'
    | '/$companySlug/schema'
    | '/$companySlug'
    | '/$companySlug/jobs/new'
    | '/$companySlug/reports/new'
    | '/$companySlug/runs/$runId'
    | '/$companySlug/jobs'
    | '/$companySlug/reports'
    | '/$companySlug/runs'
    | '/$companySlug/jobs/$jobId/edit'
    | '/$companySlug/reports/$reportId/edit'
    | '/$companySlug/reports/$reportId'
  id:
    | '__root__'
    | '/_authed'
    | '/login'
    | '/_authed/$companySlug'
    | '/_authed/settings'
    | '/_authed/'
    | '/_authed/$companySlug/license'
    | '/_authed/$companySlug/quarantine'
    | '/_authed/$companySlug/schema'
    | '/_authed/$companySlug/'
    | '/_authed/$companySlug/jobs/new'
    | '/_authed/$companySlug/reports/new'
    | '/_authed/$companySlug/runs/$runId'
    | '/_authed/$companySlug/jobs/'
    | '/_authed/$companySlug/reports/'
    | '/_authed/$companySlug/runs/'
    | '/_authed/$companySlug/jobs/$jobId/edit'
    | '/_authed/$companySlug/reports/$reportId/edit'
    | '/_authed/$companySlug/reports/$reportId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthedRoute: typeof AuthedRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/': {
      id: '/_authed/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthedIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/settings': {
      id: '/_authed/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthedSettingsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/$companySlug': {
      id: '/_authed/$companySlug'
      path: '/$companySlug'
      fullPath: '/$companySlug'
      preLoaderRoute: typeof AuthedCompanySlugRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/$companySlug/': {
      id: '/_authed/$companySlug/'
      path: '/'
      fullPath: '/$companySlug/'
      preLoaderRoute: typeof AuthedCompanySlugIndexRouteImport
      parentRoute: typeof AuthedCompanySlugRoute
    }
    '/_authed/$companySlug/schema': {
      id: '/_authed/$companySlug/schema'
      path: '/schema'
      fullPath: '/$companySlug/schema'
      preLoaderRoute: typeof AuthedCompanySlugSchemaRouteImport
      parentRoute: typeof AuthedCompanySlugRoute
    }
    '/_authed/$companySlug/quarantine': {
      id: '/_authed/$companySlug/quarantine'
      path: '/quarantine'
      fullPath: '/$companySlug/quarantine'
      preLoaderRoute: typeof AuthedCompanySlugQuarantineRouteImport
      parentRoute: typeof AuthedCompanySlugRoute
    }
    '/_authed/$companySlug/license': {
      id: '/_authed/$companySlug/license'
      path: '/license'
      fullPath: '/$companySlug/license'
      preLoaderRoute: typeof AuthedCompanySlugLicenseRouteImport
      parentRoute: typeof AuthedCompanySlugRoute
    }
    '/_authed/$companySlug/runs/': {
      id: '/_authed/$companySlug/runs/'
      path: '/runs'
      fullPath: '/$companySlug/runs/'
      preLoaderRoute: typeof AuthedCompanySlugRunsIndexRouteImport
      parentRoute: typeof AuthedCompanySlugRoute
    }
    '/_authed/$companySlug/reports/': {
      id: '/_authed/$companySlug/reports/'
      path: '/reports'
      fullPath: '/$companySlug/reports/'
      preLoaderRoute: typeof AuthedCompanySlugReportsIndexRouteImport
      parentRoute: typeof AuthedCompanySlugRoute
    }
    '/_authed/$companySlug/jobs/': {
      id: '/_authed/$companySlug/jobs/'
      path: '/jobs'
      fullPath: '/$companySlug/jobs/'
      preLoaderRoute: typeof AuthedCompanySlugJobsIndexRouteImport
      parentRoute: typeof AuthedCompanySlugRoute
    }
    '/_authed/$companySlug/runs/$runId': {
      id: '/_authed/$companySlug/runs/$runId'
      path: '/runs/$runId'
      fullPath: '/$companySlug/runs/$runId'
      preLoaderRoute: typeof AuthedCompanySlugRunsRunIdRouteImport
      parentRoute: typeof AuthedCompanySlugRoute
    }
    '/_authed/$companySlug/reports/new': {
      id: '/_authed/$companySlug/reports/new'
      path: '/reports/new'
      fullPath: '/$companySlug/reports/new'
      preLoaderRoute: typeof AuthedCompanySlugReportsNewRouteImport
      parentRoute: typeof AuthedCompanySlugRoute
    }
    '/_authed/$companySlug/jobs/new': {
      id: '/_authed/$companySlug/jobs/new'
      path: '/jobs/new'
      fullPath: '/$companySlug/jobs/new'
      preLoaderRoute: typeof AuthedCompanySlugJobsNewRouteImport
      parentRoute: typeof AuthedCompanySlugRoute
    }
    '/_authed/$companySlug/reports/$reportId/': {
      id: '/_authed/$companySlug/reports/$reportId/'
      path: '/reports/$reportId'
      fullPath: '/$companySlug/reports/$reportId/'
      preLoaderRoute: typeof AuthedCompanySlugReportsReportIdIndexRouteImport
      parentRoute: typeof AuthedCompanySlugRoute
    }
    '/_authed/$companySlug/reports/$reportId/edit': {
      id: '/_authed/$companySlug/reports/$reportId/edit'
      path: '/reports/$reportId/edit'
      fullPath: '/$companySlug/reports/$reportId/edit'
      preLoaderRoute: typeof AuthedCompanySlugReportsReportIdEditRouteImport
      parentRoute: typeof AuthedCompanySlugRoute
    }
    '/_authed/$companySlug/jobs/$jobId/edit': {
      id: '/_authed/$companySlug/jobs/$jobId/edit'
      path: '/jobs/$jobId/edit'
      fullPath: '/$companySlug/jobs/$jobId/edit'
      preLoaderRoute: typeof AuthedCompanySlugJobsJobIdEditRouteImport
      parentRoute: typeof AuthedCompanySlugRoute
    }
  }
}

interface AuthedCompanySlugRouteChildren {
  AuthedCompanySlugLicenseRoute: typeof AuthedCompanySlugLicenseRoute
  AuthedCompanySlugQuarantineRoute: typeof AuthedCompanySlugQuarantineRoute
  AuthedCompanySlugSchemaRoute: typeof AuthedCompanySlugSchemaRoute
  AuthedCompanySlugIndexRoute: typeof AuthedCompanySlugIndexRoute
  AuthedCompanySlugJobsNewRoute: typeof AuthedCompanySlugJobsNewRoute
  AuthedCompanySlugReportsNewRoute: typeof AuthedCompanySlugReportsNewRoute
  AuthedCompanySlugRunsRunIdRoute: typeof AuthedCompanySlugRunsRunIdRoute
  AuthedCompanySlugJobsIndexRoute: typeof AuthedCompanySlugJobsIndexRoute
  AuthedCompanySlugReportsIndexRoute: typeof AuthedCompanySlugReportsIndexRoute
  AuthedCompanySlugRunsIndexRoute: typeof AuthedCompanySlugRunsIndexRoute
  AuthedCompanySlugJobsJobIdEditRoute: typeof AuthedCompanySlugJobsJobIdEditRoute
  AuthedCompanySlugReportsReportIdEditRoute: typeof AuthedCompanySlugReportsReportIdEditRoute
  AuthedCompanySlugReportsReportIdIndexRoute: typeof AuthedCompanySlugReportsReportIdIndexRoute
}

const AuthedCompanySlugRouteChildren: AuthedCompanySlugRouteChildren = {
  AuthedCompanySlugLicenseRoute: AuthedCompanySlugLicenseRoute,
  AuthedCompanySlugQuarantineRoute: AuthedCompanySlugQuarantineRoute,
  AuthedCompanySlugSchemaRoute: AuthedCompanySlugSchemaRoute,
  AuthedCompanySlugIndexRoute: AuthedCompanySlugIndexRoute,
  AuthedCompanySlugJobsNewRoute: AuthedCompanySlugJobsNewRoute,
  AuthedCompanySlugReportsNewRoute: AuthedCompanySlugReportsNewRoute,
  AuthedCompanySlugRunsRunIdRoute: AuthedCompanySlugRunsRunIdRoute,
  AuthedCompanySlugJobsIndexRoute: AuthedCompanySlugJobsIndexRoute,
  AuthedCompanySlugReportsIndexRoute: AuthedCompanySlugReportsIndexRoute,
  AuthedCompanySlugRunsIndexRoute: AuthedCompanySlugRunsIndexRoute,
  AuthedCompanySlugJobsJobIdEditRoute: AuthedCompanySlugJobsJobIdEditRoute,
  AuthedCompanySlugReportsReportIdEditRoute:
    AuthedCompanySlugReportsReportIdEditRoute,
  AuthedCompanySlugReportsReportIdIndexRoute:
    AuthedCompanySlugReportsReportIdIndexRoute,
}

const AuthedCompanySlugRouteWithChildren =
  AuthedCompanySlugRoute._addFileChildren(AuthedCompanySlugRouteChildren)

interface AuthedRouteChildren {
  AuthedCompanySlugRoute: typeof AuthedCompanySlugRouteWithChildren
  AuthedSettingsRoute: typeof AuthedSettingsRoute
  AuthedIndexRoute: typeof AuthedIndexRoute
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedCompanySlugRoute: AuthedCompanySlugRouteWithChildren,
  AuthedSettingsRoute: AuthedSettingsRoute,
  AuthedIndexRoute: AuthedIndexRoute,
}

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthedRoute: AuthedRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
